import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { Policy, Statement } from '../../models/policy.model';
import { authToken } from '../../scripts/authentication.script';

export class ApiDigitalAuthPolicy {
  static apiResponse: ApiResponse

  public static async getPolicies(
    api_key: string,
    activeOnly: boolean = true
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      this.apiResponse = {
        status: 200,
        message: 'Success',
        data: [] as Policy[]
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/company/policies${activeOnly ? '?active=true' : ''}`
      let config: any = { headers: { Authorization: authToken() } }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data?.policies ?? response.data?.data ?? response.data?.policies ?? []
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async getPolicy(
    api_key: string,
    policy_id: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      this.apiResponse = { status: 200, message: 'Success', data: null }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/company/policies/${policy_id}`
      let config: any = { headers: { Authorization: authToken() } }

      await axios.get(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async createPolicy(
    api_key: string,
    payload: { name: string; description?: string; statements: Statement[] }
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      this.apiResponse = { status: 201, message: 'Created', data: null }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/company/policies`
      let config: any = { headers: { Authorization: authToken() } }

      await axios.post(url, payload, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async updatePolicy(
    api_key: string,
    policy_id: string,
    payload: { name?: string; description?: string; statements?: Statement[]; is_active?: boolean }
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      this.apiResponse = { status: 200, message: 'Success', data: null }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/company/policies/${policy_id}`
      let config: any = { headers: { Authorization: authToken() } }

      await axios.put(url, payload, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }

  public static async deletePolicy(
    api_key: string,
    policy_id: string
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      this.apiResponse = { status: 200, message: 'Success', data: null }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_AUTH}/api/v1/${api_key}/company/policies/${policy_id}`
      let config: any = { headers: { Authorization: authToken() } }

      await axios.delete(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response?.status ?? 500,
          message: error.response?.statusText ?? 'Error',
          data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
        }
      })
    }

    return this.apiResponse
  }
}
